export default __webpack_public_path__ + "static/media/Hernández.e443ac79.png";